import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { withRouter, Link } from "react-router-dom"
import { isEmpty, size } from "lodash"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import {showSuccessToast} from "helpers/function_helper"
import ReactDrawer from 'react-drawer';
import classNames from "classnames"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  UncontrolledTooltip,
} from "reactstrap"
import RightDrawer from "../../components/Common/RightDrawer"
//redux
import { useSelector, useDispatch } from "react-redux"
import SweetAlert from "react-bootstrap-sweetalert"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import { getAllUnits as onGetAllUnits } from "store/products/actions"
import { deleteItemDirect as onDeleteItemDirect } from "helpers/backend_helper"
import Loader from "components/Common/Loader"

const UnitList = props => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(onGetAllUnits(true))
  }, [dispatch]);

  const { unitList } = useSelector(state => ({
    unitList: state.Products.units,
  }))

  const [isEdit, setIsEdit] = useState(false)

  const [newItemToAdd, setNewItemToAdd] = useState()
  const [position, setPosition] = useState()
  const [open, setOpen] = useState(false)
  const [detailsForEdit, setDetailsForEdit] = useState()
  const [showDeletePopUp, setShowDeletePopUp] = useState(false)
  const [showErrorPopUp, setShowErrorPopUp] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [deleteMessage, setDeleteMessage] = useState('')
  const [itemToDelete, setItemToDelete] = useState()
  const [showLoading, setShowLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  
  function addNewItem(item) {
    setPosition('right')
    setOpen(!open)
    setNewItemToAdd(item)
  }
  const onDrawerClose = () => {
    setOpen(false);
  }
  const onNewlyAddedValue = (value) => {
  }
  
  //pagination customization
  const pageOptions = {
    sizePerPage: 10,
    totalSize: size(unitList), 
    custom: true,
    onPageChange: (page, sizePerPage) => {
      setCurrentPage(page)
    }
  }
  const { SearchBar } = Search


  const UnitListColumns = () => [
    {
      dataField: "value",
      text: "ID",
      sort: true,
      sortValue: (cell, row) => {
      }
    },
    {
      dataField: "name",
      text: "Name",
      sort: true,
      formatter: (cellContent, row) => (
        <div className="text-body fw-bold">
          {cellContent}
        </div>
      ),
    },
    {
      dataField: "details",
      text: "Details",
      sort: true,
      tdStyle: { whiteSpace: 'normal' },
      thStyle: { whiteSpace: 'normal' },
      searchable: true
    },
    {
      dataField: "action",
      isDummyField: true,
      text: "Action",
      formatter: (cellContent, item) => (
        <>
          <div className="d-flex gap-3">
            <Link
              to="#"
              className="text-success"
              onClick={() => handleEditClick(item)}
            >
              <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
              <UncontrolledTooltip placement="top" target="edittooltip">
                Edit
              </UncontrolledTooltip>
            </Link>
            <Link
              to="#"
              className="text-danger"
              onClick={() => handleDeleteClick(item)}
            >
              <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
              <UncontrolledTooltip placement="top" target="deletetooltip">
                Delete
              </UncontrolledTooltip>
            </Link>
          </div>
        </>
      ),
    },
  ]

  const handleEditClick = arg =>{
    setDetailsForEdit(arg)
    setIsEdit(true)
    addNewItem('Unit')
  }

  const handleDeleteClick = arg => {
    setItemToDelete(arg)
    setDeleteMessage(arg.name)
    setShowDeletePopUp(true)
  }

  const confirmDelete = async () =>{
    setShowDeletePopUp(false)
    setShowLoading(true)
    const response =  await onDeleteItemDirect({
      'key': itemToDelete.value,
      'value' : 'Unit'
    }, '')
    setShowLoading(false)
    if(response.status == 'success'){
      dispatch(onGetAllUnits(false))
      showSuccessToast('Deleted Successfully!!!')
    }
    else if(response.status == 'failure'){
      setErrorMessage(response.errorResponse)
      setShowErrorPopUp(true)
    }
  }

  const defaultSorted = [
    {
      dataField: "value",
      order: "asc",
    },
  ]

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>View All Units | Flamingo</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Settings" breadcrumbItem="Unit" />
          <Loader showLoader={showLoading} />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField="value"
                    columns={UnitListColumns()}
                    data={unitList}
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField="value"
                        data={unitList}
                        columns={UnitListColumns()}
                        bootstrap4
                        search
                      >
                        {toolkitProps => (
                          <React.Fragment>
                            <Row className="mb-2">
                              <Col sm="4">
                                <div className={classNames({"d-none": currentPage !== 1},"search-box me-2 mb-2 d-inline-block")}>
                                  <div className="position-relative">
                                    <SearchBar {...toolkitProps.searchProps} />
                                    <i className="bx bx-search-alt search-icon" />
                                  </div>
                                </div>
                              </Col>
                              <Col sm="8">
                                <div className="text-sm-end">
                                  <Button
                                    type="button"
                                    color="success"
                                    className="btn-rounded  mb-2 me-2"
                                    onClick={() => {
                                      addNewItem('Unit')
                                      setIsEdit(false)
                                    }}
                                    disabled={open}
                                  >
                                    <i className="mdi mdi-plus me-1" />
                                    Add New Unit
                                  </Button>
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    keyField="id"
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    defaultSorted={defaultSorted}
                                    classes={
                                      "table align-middle  table-check"
                                    }
                                    headerWrapperClasses={"table-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row className="align-items-md-center mt-30">
                              <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </Col>
                            </Row>
                          </React.Fragment>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <ReactDrawer
        open={open}
        position={position}
        onClose={onDrawerClose}
      >
        <RightDrawer 
          onClose={onDrawerClose} 
          currentItem={newItemToAdd} 
          onNewlyAddedValue={onNewlyAddedValue}
          selectedId={null}
          detailsForEdit={detailsForEdit}
          isEdit={isEdit}
        />
      </ReactDrawer>
      {showDeletePopUp ? (
        <SweetAlert
          title="Are you sure?"
          warning
          showCancel
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            confirmDelete()
          }}
          onCancel={() => {
            setShowDeletePopUp(false)
          }}
        >
          <p>Deleting Unit : <b>{deleteMessage}</b></p>
          You won't be able to revert this!
        </SweetAlert>
      ) : null}
      {showErrorPopUp ? (
        <SweetAlert
          error
          title="Failed"
          onConfirm={() => {
            setShowErrorPopUp(false)
          }}
        >
          {errorMessage}
        </SweetAlert>
      ) : null}
    </React.Fragment>
  )
}

UnitList.propTypes = {
  unitList: PropTypes.array,
  onGetAllUnits: PropTypes.func,
}

export default withRouter(UnitList)
